<template>
  <v-data-table
    :loading="loading"
    :headers="headers"
    :items="items"
    :search="search"
  >
    <template v-slot:item.groups="{ item }">
      <v-row class="my-0 py-0">
        <v-col class="my-0 py-0"
          v-for="(list, idx) in getGroupsLists(item)"
          :key="idx"
        >
          <simple-list :items="list"/>
        </v-col>
      </v-row>
    </template>
    <template v-slot:item.parentLevel="{ item }">
      <v-row class="my-0 py-0">
        <v-col>
          {{item.parentLevel && item.parentLevel.name}}
        </v-col>
      </v-row>
    </template>
    <template v-slot:item.role="{ item }">
      <v-row class="my-0 py-0">
        <v-col>
          {{item.role.title}}
        </v-col>
      </v-row>
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="my-3">
        <v-btn
          small
          :id="`groups-table-edit-btn-${item.id}`"
          @click="() => $emit('edit', item)"
          v-if-has-permission:hide="editRolePermission"
        >
          Edit Level
        </v-btn>
      </div>
      <div class="my-3">
        <v-btn
          small
          color="error"
          :id="`groups-table-delete-btn-${item.id}`"
          @click="() => $emit('delete', item)"
          v-if-has-permission:hide="deleteRolePermission"
        >
          Delete Level
        </v-btn>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import SimpleList from '@/components/utils/SimpleList';
import groupsMixin from '@/mixins/groupsMixin';

export default {
  name: 'AdminRoleLevelsTable',
  mixins: [groupsMixin],
  components: {
    SimpleList,
  },
  props: {
    search: String,
  },
  data: () => ({
    items: [],
    headers: [
      { text: 'Level Name', value: 'name' },
      { text: 'Specialized Groups', value: 'groups' },
      { text: 'Parent', value: 'parent.name' },
      { text: 'Role', value: 'role.title' },
      { text: 'Actions', value: 'actions', width: 300 },
    ],
    loading: false,
  }),
  computed: {
    editRolePermission: vm => vm.$permissions.EDIT_ROLE_LEVELS,
    deleteRolePermission: vm => vm.$permissions.DELETE_ROLE_LEVELS,
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$requests.get('/v1/role_levels')
        .then(response => {
          this.items = response.data;
        })
        .catch(() => {
          this.$toast.error('Could not resolve levels...', { timeout: 3000 });
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
